import { HostListener, inject, Injectable, NgZone } from "@angular/core";
import {
  BehaviorSubject,
  debounceTime,
  fromEvent,
  map,
  Observable,
} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DeviceServiceService {
  readonly isMobile$: Observable<boolean>;
  readonly mobileSize = window.matchMedia("(max-width: 992px)");

  private isMobileBehavior = new BehaviorSubject<boolean>(false);

  #ngZone = inject(NgZone);

  constructor() {
    this.isMobile$ = this.isMobileBehavior.asObservable();
  }

  onResize(): Observable<{ width: number; height: number }> {
    return new Observable((observer) => {
      this.#ngZone.runOutsideAngular(() => {
        fromEvent(window, "resize")
          .pipe(
            debounceTime(0),
            map(() => ({
              width: window.innerWidth,
              height: window.innerHeight,
            }))
          )
          .subscribe((size) => {
            this._setDeviceCheck(this.mobileDeviceListener());
            this.#ngZone.run(() => {
              observer.next(size);
            });
          });
      });
    });
  }

  mobileDeviceListener(): boolean {
    const userAgent = navigator.userAgent;
    const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    if (/android/i.test(userAgent) && this.mobileSize.matches) return true;

    if (/iPhone|iPad|iPod/i.test(userAgent) && this.mobileSize.matches) return true;

    // iPad ที่แสดงเป็น Mac
    if (
      /Macintosh/i.test(userAgent) &&
      isTouch &&
      screen.width <= 1366 &&
      screen.height <= 1366
    )
      return true;

    return false;
  }

  _setDeviceCheck(value: boolean): void {
    this.isMobileBehavior.next(value);
  }
}
